module.exports = __webpack_public_path__ + "static/media/toyota-checkmark.b69a9891.svg";